import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ModalContainer = styled.div`
  padding: ${pxToRem('64px')} 0;
`;

export const ModalContent = styled.div`
  text-align: center;
  border-radius: ${pxToRem('30px')};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  float: right;
  margin-right: ${pxToRem('20px')};

  :hover {
    cursor: pointer;
  }
`;
